import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import HubCard from '../components/HubCard';
import { sapGuideSections, sapPracticeGroups } from '../data/awsSapGuideData';

const AWSSAPHubPage: React.FC = () => {
  const totalQ = sapPracticeGroups.reduce((n, g) => n + g.questions.length, 0);
  return (
    <Layout>
      <div className="page-hero">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 6%' }}>
          <div style={{ fontSize: '0.9rem', color: 'var(--gray-600)', marginBottom: '12px' }}>
            <Link to="/programs" style={{ color: 'var(--blue)' }}>Programs</Link> / AWS Solutions Architect Professional
          </div>
          <h1>AWS Solutions Architect Professional Learning Hub</h1>
          <p>Study the SAP-C02 exam topic by topic, then test yourself with scenario-based questions. Pick the option that matches where you are today.</p>
          <div style={{ marginTop: '16px', display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <span className="section-tag">Advanced</span>
            <span className="section-tag">SAP-C02</span>
            <span className="section-tag orange">{sapGuideSections.length} study sections</span>
          </div>
        </div>
      </div>

      <div className="section">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 6%' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '28px', paddingBottom: '16px', borderBottom: '2px solid var(--blue-soft)' }}>
            <div style={{ width: '46px', height: '46px', borderRadius: '12px', background: 'var(--blue-pale)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem' }}>🧭</div>
            <div>
              <h2 style={{ fontSize: '1.6rem', fontWeight: 800, color: 'var(--gray-800)' }}>Choose your starting point</h2>
              <p style={{ fontSize: '0.82rem', color: 'var(--gray-400)' }}>You can move between the two at any time</p>
            </div>
          </div>

          <div className="cf-hub2">
            <HubCard
              tint="#FFF7ED" image="/images/hub/architect-guide-bg.svg" title="1. SAP Guide" tag="Study every exam topic in depth"
              desc="A complete study guide for SAP-C02: each topic explained from beginner to exam level, with architecture diagrams, comparison tables, exam tips and cheat sheets."
              items={['Foundations, IAM, networking, compute, storage and databases', 'Migration, HA/DR, cost optimization and advanced architectures', 'Exam strategy and a 60-day study roadmap']}
              to="/aws-sap-guide" cta="Open the SAP guide" btn="btn-orange"
            />
            <HubCard
              tint="#EFF6FF" image="/images/hub/architect-practice-bg.svg" title="2. Practice" tag="Test what you know"
              desc="Scenario-based questions with instant feedback, a detailed reason for the right answer and why each wrong option fails."
              items={[`${totalQ} questions in ${sapPracticeGroups.length} sets`, 'By difficulty and by mock exam', 'Single and multiple-answer questions, running score']}
              to="/aws-sap-practice" cta="Start practising" btn="btn-blue"
            />
          </div>

          <img src="/images/hub/path-sap.svg" alt="Study, practise, take the exam" style={{ display: 'block', width: '100%', maxWidth: '460px', height: 'auto', margin: '26px auto' }} />

          <div style={{ background: 'var(--orange-pale)', borderLeft: '4px solid var(--orange)', borderRadius: '12px', padding: '12px 18px', color: 'var(--gray-800)', fontSize: '.94rem' }}>
            <b style={{ color: 'var(--orange)' }}>Not sure where to start?</b> Read the guide section by section, and after each section try a set of practice questions to check what stuck.
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AWSSAPHubPage;
